module.exports = __webpack_public_path__ + "static/media/icon-download.f7093450.svg";